import {
  Alert,
  Box,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  useDeletePropertyMutation,
  useToggleActiveMutation,
} from "../../features/properties/propertiesApiSlice";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Delete, Edit, Visibility, VisibilityOff } from "@mui/icons-material";

const ActionButtons = ({ property, propertyState, setPropertyState }) => {
  const [alert, setAlert] = useState({ message: "", severity: "" }); // Alert state
  // const [actionType, setActionType] = useState(""); // To track whether action is delete
  const navigate = useNavigate();

  const [
    toggleActive,
    {
      isLoading: isPubLoading,
      //   isSuccess: isPubSuccess,
      //   isError: isPubError,
      //   error: puberror,
    },
  ] = useToggleActiveMutation();

  const [
    deleteProperty,
    { isLoading: isDeleting },
    // { isSuccess: isDelSuccess, isError: isDelError, error: delerror },
  ] = useDeletePropertyMutation();

  const handleEdit = () => navigate(`/my-properties/edit/${property.id}`);

  // Publish Functionality Start
  const handlePublish = async () => {
    // await toggleActive({ id: property.id, isActive: true });
    try {
      const newStatus = !propertyState.isActive;

      const response = await toggleActive({
        id: property.id,
        isActive: newStatus, // Toggle status
      }).unwrap();

      // Update the propertyState
      setPropertyState((prev) => ({
        ...prev,
        isActive: newStatus,
      }));

      setAlert({
        message: response.message || "Property status updated successfully!",
        severity: "success",
      });
    } catch (error) {
      setAlert({
        message: error.data?.message || "Failed to update property status.",
        // message: response.message || "Failed to update property status.",
        severity: "error",
      });
    }
  };
  // Publish Functionality End

  // Delete Functionality Start
  const [open, setOpen] = useState(false); // Track dialog open state

  const handleOpenDialog = () => {
    setOpen(true); // Open the confirmation dialog
  };

  const handleCloseDialog = () => {
    setOpen(false); // Close the confirmation dialog
  };

  const handleConfirmDelete = async () => {
    try {
      // await onDelete(property._id); // Call delete function with the property ID
      const response = await deleteProperty({ id: property.id }).unwrap();

      // setOpen(false); // Close the dialog
      // setActionType("delete");
      // setAlert({
      //   message: response.message || "Property deleted successfully.",
      //   severity: "success",
      // });

      // Navigate with state
      navigate("/my-properties", {
        state: {
          message: response.message || "Property deleted successfully",
          severity: "success",
          refreshTrigger: Date.now(), // Unique value
        },
      });
    } catch (error) {
      console.error("Failed to delete property:", error);
      setOpen(false);
      setAlert({
        message: error.data?.message || "Failed to delete property.",
        severity: "error",
      });
    }
    // finally {
    //   setOpen(false);
    // }
  };

  // Handle snackbar close
  const handleSnackbarClose = (event, reason) => {
    setAlert({ message: "", severity: "" }); // Clear alert message and severity
    // if (actionType === "delete") {
    //   navigate("/my-properties"); // Redirect to property list after delete
    // }
    if (reason === "clickaway") {
      return;
    }
  };

  // // Handle the snackbar exit event
  // const handleSnackbarExited = () => {
  //   if (actionType === "delete") {
  //     navigate("/my-properties"); // Redirect to property list after delete
  //   }
  // };
  // Delete Functionality End

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1, // Spacing between buttons
        // flexDirection: { xs: "column", sm: "row" }, // Stack vertically on small screens
        // width: { xs: "100%", sm: "auto" }, // Ensure buttons are full-width on small screens
      }}
    >
      <Tooltip
        title={
          propertyState.isActive
            ? // ? "This unit is available for rent"
              // : "This unit is currently occupied"
              "This property is currently displayed to public"
            : "This property is currently not displayed to public"
        }
        arrow
      >
        <Button
          variant="contained"
          color={propertyState.isActive ? "warning" : "success"}
          size="large"
          startIcon={
            propertyState.isActive ? <VisibilityOff /> : <Visibility />
          }
          onClick={handlePublish}
          disabled={isPubLoading}
        >
          {propertyState.isActive ? "UnPublish" : "Publish"}
        </Button>
      </Tooltip>
      <Button
        variant="contained"
        color="info"
        size="large"
        startIcon={<Edit />}
        onClick={handleEdit}
      >
        Edit
      </Button>
      <Button
        variant="contained"
        color="error"
        size="large"
        startIcon={<Delete />}
        onClick={handleOpenDialog}
      >
        Delete
      </Button>

      {/* Confirmation Dialog */}
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>
          Delete Property
          <IconButton
            sx={{ position: "absolute", right: 8, top: 8 }}
            onClick={handleCloseDialog}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this property? */}
            <Box sx={{ textAlign: "center" }}>
              {/* Are you sure you want to delete this property? <br />
              This will permanently remove all associated units and their
              images.  */}
              Warning: Deleting this property will also erase all associated
              units and uploaded images permanently.
            </Box>
            {/* This action cannot be undone. */}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={handleCloseDialog}
            color="primary"
            variant="outlined"
            disabled={isDeleting} // Disable cancel while deleting
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            disabled={isDeleting} // Disable delete to prevent double-click
            // startIcon={!isDeleting ? <Delete /> : null} // Hide icon while loading
            startIcon={
              isDeleting ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <Delete />
              )
            }
          >
            {/* Delete */}
            {isDeleting
              ? // <CircularProgress size={24} color="inherit" />
                "Deleting..."
              : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar Alert for Success/Failure */}
      <Snackbar
        open={!!alert.message} // Show if message exists
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={handleSnackbarClose} // Close the snackbar and potentially redirect
        // TransitionProps={{
        //   onExited: () => {
        //     handleSnackbarExited();
        //   },
        // }}
        // message={alert.message}
      >
        <Alert
          severity={alert.severity || "info"}
          // onClose={() => setAlert({ message: "", severity: "" })}
          onClose={handleSnackbarClose} // Use the same handler
          // variant="filled" // Optional: 'filled' usually looks better for alerts
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ActionButtons;
